export const TopicEnum = {
  enrollment_information: 'enrollment_information',
  pre_enrollment_and_enrollment_incidents:
    'pre_enrollment_and_enrollment_incidents',
  withdrawal_and_fee_refund: 'withdrawal_and_fee_refund',
  schedule_change_or_swaps: 'schedule_change_or_swaps',
  transcript_transfer: 'transcript_transfer',
  course_repetition: 'course_repetition',
  degree_issuance: 'degree_issuance',
  free_candidate_enrollment: 'free_candidate_enrollment',
  summer_courses_enrollment: 'summer_courses_enrollment',
  special_courses_enrollment: 'special_courses_enrollment',
  others: 'others',
};
